import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { requestLoginModal } from '@corefront/redux-aba';
import { isLoggedInSelector } from '../../redux/reducers/app/params';

const AuthLink = React.forwardRef(({ onClick, ...props }, ref) => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(isLoggedInSelector);

  const clickHandler = (event) => {
    if (typeof onClick === 'function') {
      onClick(event);
    }

    /**
     * If parent decide to prevent default behavior
     * do not run default component logic on click event
     */
    if (event.isDefaultPrevented()) return;

    if (isLoggedIn) return;

    // Do not allow to follow by link
    event.preventDefault();

    // and request show login modal
    dispatch(requestLoginModal());
  };

  return (
    <Link ref={ref} {...props} onClick={clickHandler} data-testid="auth-link" />
  );
});

AuthLink.propTypes = {
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func])
    .isRequired,
  onClick: PropTypes.func,
};

export default AuthLink;
